import { Observable } from 'rxjs';

/**
 * An abstract service interface for confirmation dialogs.
 * Implement this interface in client app to provide confirmation logic for closing the chatbot.
 */
export abstract class IConfirmationService {
  /**
   * Prompts the user to confirm closing the chatbot.
   * @returns An Observable that emits `true` if the user confirms, or `false` otherwise.
   */
  abstract confirmCloseChatbot(): Observable<boolean>;

  /**
   * Prompts the user to an alert that he must fill the equation.
   * @returns An Observable that emits `true` if the user click ok
   */
  abstract alertEmptyEquation(): Observable<boolean>;
}

